module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABAAQMAAACQp+OdAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAGUExURUdwTG+QxDHphP8AAAABdFJOUwBA5thmAAAA20lEQVQoz5XSoW7cQAAE0Oe60rIzLYji3zjU+6WDAZXsov6Wg/IblgpKj3XB5ibgvFJZlUFPmoHDpzKngiFJkrsx+ZskpuR3kpiT143JJVl3isuNK8WycaZY8ERxx6ljpGgoHSeK2scVLx23A8N+YFwPFAdOHU8d544rX4vKjeeisnMpqmFn+XXg/e1RDe3PY1zaolJNbVb54blNKt+dW1GZXdsXlenn3qiM2R4Ysj4gDnzr8B80GP7FHcZGoFSWFVNl2TBXLhW5MSdJ9o6NkiRZGZMkkCTtc3/wAXCbkor+psANAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/img/extlink.png
// module id = 27
// module chunks = 0